import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=8558f772&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=8558f772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8558f772",
  null
  
)

export default component.exports